export const ProductLoading = () => {
  return (
    <div className="product-loading">
      <div className="product-hero__price"></div>
      <div className="product-hero__component">
        <div className="product-hero__availability__wrap"></div>
        <div className="line-2"></div>
      </div>
    </div>
  );
};
